module.exports = __webpack_public_path__ + "static/img/Charlie_Curnow_mobile.bc72e03.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Charlie_Curnow_mobile.jpg
// module id = q8Eq
// module chunks = 0